import { FC } from "react";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { ProTooltip } from '../../antd';
import RouteLink from '../../RouteLink';
import classNames from "classnames";
import { ScanPageHeaderItemEnum, ScanPageHeaderTitleProps } from "../interface";

const Title: FC<ScanPageHeaderTitleProps> = props => {
  const { className, style, warehouseName, title, otherNode, typeName, routeLinkProps, tootipIcon, tootipText, } = props;
  const classes = classNames('yb-card-item-head', 'scan-page-header-left-title', className);
  return (
    <div className={classes} style={style}>
      <div className="title-text">
        {!!warehouseName && <span className="warehouse-name">【{warehouseName}】</span>}
        <span>{title}</span>
      </div>
      {!!tootipText && (
        <ProTooltip title={tootipText}>
          <div className="title-tootip">{tootipIcon}</div>
        </ProTooltip>
      )}
      <div className="order-info">
        {
          typeName && <div>{typeName}-</div>
        }
        {
          routeLinkProps && <RouteLink {...routeLinkProps} />
        }
      </div>
      <div>{otherNode}</div>
    </div>
  );
};

Title.displayName = ScanPageHeaderItemEnum.Title;
Title.defaultProps = {
  tootipIcon: <QuestionCircleOutlined />
};

export default Title;